/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVlastnost extends GContentBase<SeznamAdmVlastnostObj> {
        private seznamObj: SeznamAdmVlastnostObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVlastnostObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVlastnost",
                contentCaption: "jres:33000455", //RC 33000455 : Vlastnosti
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_vla}"
                },
                gridSettings: {
                    columnOrder: "kod,nazev,zkratka,ixs_vla,dat_zmena,zmenu_provedl,priz_edit,priz_add,priz_del,typ_vla_txt,dat_typ_txt,velikost,maska,kod_form,priz_ixs_rpp,priz_pov"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmVlastnostObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            this.detailCnt = $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVlastnost", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmVlastnost",
                newRecord: isNew,
                ixs_vla: isNew == true ? null : data.ixs_vla
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamAdmVlastnostObjekt: {
                    icon: "fa-link",
                    caption: "jres:33000466", 
                    run: () => {
                        this.openSeznamAdmVlastnostObjekt();
                    }
                },
                actOpenHromadnePridaniVlastnostiTypObjektu: {
                    icon: "fa-link",
                    caption: "jres:33000500", 
                    run: () => {
                        this.openHromadnePridaniVlastnostiTypObjektu();
                    }
                },
                actOpenSeznamAdmVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000477", //RC 33000477 : Nav�zan� typy dokument�
                    tooltip: "jres:33000512",
                    run: () => {
                        this.openSeznamAdmVlastnostTypDokumentu()
                    }
                },
                actOpenHromadnePridaniVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000513", //RC 33000513 : P�i�adit p�eddefinovan� hromadn�
                    run: () => {
                        this.openHromadnePridaniVlastnostTypDokumentu();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison", "actOpenDialogVyberovaSkupina", {
                type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                    {
                        type: "static", caption: "jres:33000485", icon: "fa-link", children: [
                            { action: this.cnt.actions.actOpenSeznamAdmVlastnostObjekt },
                            { action: this.cnt.actions.actOpenHromadnePridaniVlastnostiTypObjektu },
                        ]
                    },
                    {
                        action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu,
                        children: [
                            { action: this.cnt.actions.actOpenHromadnePridaniVlastnostTypDokumentu }
                        ]
                    }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                {
                    type: "static", caption: "jres:33000485", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenSeznamAdmVlastnostObjekt },
                        { action: this.cnt.actions.actOpenHromadnePridaniVlastnostiTypObjektu },
                    ]
                },
                {
                    action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu,
                    children: [
                        { action: this.cnt.actions.actOpenHromadnePridaniVlastnostTypDokumentu }
                    ]
                }
            ])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmVlastnost.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            var isVycet = true;
            if (this.grid) {
                var activeRow = this.grid.ggrid("activeRow");
                if (activeRow)
                    if (activeRow.typ_vla != 20)
                        isVycet = false;
            }
            this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamAdmVlastnostObjekt?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_vla),
                nazev: data["nazev"]
            }
        }

        private openHromadnePridaniVlastnostiTypObjektu() {
            var selectionData = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmVlastnostTypObjektuListDto[] = [];
            if (selectionData.length > 0) {
                selectionData.forEach((item) => {
                    data.push({
                        ixs: item["ixs_vla"],
                        ixs_txt: item["nazev"],
                        typ_vps_txt: "jres:29932128",
                        typ_vps: 20
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmVlastnostTypObjektu"], { ID: "HromadnaOperaceAdmVlastnostTypObjektu", data: data }, "", 1000, 600)
        }

        private openHromadnePridaniVlastnostTypDokumentu() {
            var selectionData = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmVlastnostTypDokumentuReadDto[] = [];
            if (selectionData.length > 0) {
                selectionData.forEach((item) => {
                    data.push({
                        ixs: item["ixs_vla"],
                        typ_vps: 20
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceVlastnostTypDokumentu"], { ID: "HromadnaOperaceVlastnostTypDokumentu", data: data }, "", 1000, 600)
        }

        private openSeznamAdmVlastnostObjekt() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow) {
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu"], {
                    Id: "SeznamAdmVlastnostTypObjektu",
                    typ_vps: 20,
                    ixs: activeRow.ixs_vla
                })
            }
        }

        private openSeznamAdmVlastnostTypDokumentu() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow) {
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypDokumentu"], {
                    Id: "SeznamAdmVlastnostTypDokumentu",
                    typ_vps: 20,
                    ixs: activeRow.ixs_vla
                })
            }
        }
    }
}


